//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VARIABLETYPES } from '@/utils/constant.js';
import METADATA from './metadata.vue';
export default {
  components: {
    METADATA,
  },
  props: {
    type: {
      type: String,
      default: 'inputs', // inputs: 输入变量   outputs: 输出变量
    },
    list: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      variableList: [],
      selectIndex: -1,
      // 元数据弹窗
      showMetadata: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set() {
        this.cancel();
      },
    },
    VARIABLETYPES() {
      return VARIABLETYPES;
    },
    title() {
      return this.type === 'inputs' ? '输入变量配置' : '输出变量配置';
    },
  },
  created() {
    this.variableList = JSON.parse(JSON.stringify(this.list));
  },
  methods: {
    addData() {
      this.variableList.push({
        name: '',
        remark: '',
        type: '',
        vale: '',
      });
    },
    changeType(type, index) {
      switch (type) {
        case 'number':
          this.variableList[index].vale = 0;
          break;
        case 'boolean':
          this.variableList[index].vale = false;
          break;
        default:
          this.variableList[index].vale = '';
      }
      this.variableList = JSON.parse(JSON.stringify(this.variableList));
    },
    cancel() {
      this.$emit('cancel', false);
    },
    submit() {
      this.$emit('save', this.variableList);
    },
    openMetadata(index) {
      this.selectIndex = index;
      this.showMetadata = true;
    },
    selectMetadata({ name }) {
      this.variableList[this.selectIndex].key = name;
      this.closeMetadata();
    },
    closeMetadata() {
      this.showMetadata = false;
      this.selectIndex = -1;
    },
    del(index) {
      this.variableList.splice(index, 1);
    },
  },
};
